import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=149015c4&scoped=true&"
import script from "./imgList.vue?vue&type=script&lang=js&"
export * from "./imgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149015c4",
  null
  
)

export default component.exports